import { nightsOnOffer } from "@quote/quote/api/init_quote/utils";
import { addDays, eachDayOfInterval, max } from "date-fns";
import { StateCreator } from "zustand";

import { ordinalShortMonthDay } from "@/utils/helpers";

import { ArrivalState, InitialDate } from "./types";

const initState = {
  dateParam: null,
  arrivalDate: null,
  departureDate: null,
  onRequest: false,
  ppPrice: 0,
  preQuoteKey: null,
  onlyForEnquiry: false,
};

export const createDateState: StateCreator<
  ArrivalState,
  [["zustand/devtools", never]]
> = (set, get) => ({
  ...initState,
  arrivalActions: {
    setDateAndPrice: (
      arrivalDate: Date,
      departureDate: Date,
      ppPrice: number,
    ) => {
      set(
        { arrivalDate, departureDate, ppPrice },
        undefined,
        "date/setDateAndPrice",
      );
    },

    setOnRequest: (onRequest: boolean) => {
      set({ onRequest }, undefined, "date/setOnRequest");
    },

    setPreQuoteKey: (preQuoteKey: string) => {
      set({ preQuoteKey }, undefined, "date/setPreQuoteKey");
    },

    setOnlyForEnquiry: (onlyForEnquiry: boolean) => {
      set({ onlyForEnquiry }, undefined, "date/setOnlyForEnquiry");
    },

    resetState: () => set(initState),
  },
  arrivalUtils: {
    getInitialDate: (dates): InitialDate => {
      const dateParam = get().dateParam;
      if (!dateParam || !dates[dateParam]) {
        return { bookable: false, date: null, ppPrice: null };
      }

      return {
        bookable: dates[dateParam].book,
        date: new Date(dateParam),
        ppPrice: dates[dateParam].price,
      };
    },

    travelDates: (nights, arrivalDate = get().arrivalDate) =>
      arrivalDate && nights
        ? eachDayOfInterval({
            start: arrivalDate,
            end: addDays(arrivalDate, nights),
          })
        : [],

    generateSummaryText: () => {
      const { arrivalDate, departureDate } = get();

      if (arrivalDate && departureDate) {
        return `${ordinalShortMonthDay(arrivalDate)} - ${ordinalShortMonthDay(departureDate)}`;
      }

      return "";
    },

    getDepartureDate: (arrivalDate, offer) => {
      const { travelDates } = get().arrivalUtils;
      const totalNights = nightsOnOffer(offer);
      const selectedDates = travelDates(totalNights, new Date(arrivalDate));
      return max(selectedDates);
    },
  },
});
